import { isEmpty } from 'lodash';
import React, { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Form, FormGroup, FormText, Input, Label, Row } from 'reactstrap';

const UTMBuilder = () => {
  toast.configure();

  const [utmData, setUtmData] = useState({
    website: '',
    source: '',
    medium: '',
    campaign: '',
    content: '',
    term: '',
  });

  const [copied, setCopied] = useState(false);
  const textareaRefs = useRef({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUtmData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAutoResize = (e) => {
    const { name } = e.target;
    const textarea = textareaRefs.current[name];
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
    handleChange(e);
  };

  const buildUTMUrl = () => {
    const { website, source, medium, campaign, content, term } = utmData;

    if (!website) return '';

    try {
      const url = new URL(website.trim());
      if (source) url.searchParams.set('utm_source', source.trim());
      if (medium) url.searchParams.set('utm_medium', medium.trim());
      if (campaign) url.searchParams.set('utm_campaign', campaign.trim());
      if (content) url.searchParams.set('utm_content', content.trim());
      if (term) url.searchParams.set('utm_term', term.trim());
      return url.toString();
    } catch (err) {
      console.warn('err', err);
      toast.error('Please enter correct website url.');
      return '';
    }
  };

  const handleCopy = () => {
    const utmUrl = buildUTMUrl();
    if (!utmUrl) return;

    navigator.clipboard.writeText(utmUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const inputsList = [
    { label: 'Website URL', value: 'website', isCompulsory: true },
    {
      label: 'UTM Source',
      value: 'source',
      slug: 'utm_source',
      info: 'e.g. newsletter, twitter, google, etc.',
      isCompulsory: true,
    },
    {
      label: 'UTM Medium',
      value: 'medium',
      slug: 'utm_medium',
      info: 'e.g. email, social, cpc, etc.',
      isCompulsory: true,
    },
    {
      label: 'UTM Campaign',
      value: 'campaign',
      slug: 'utm_campaign',
      info: 'e.g. promotion, sale, etc.',
      isCompulsory: true,
    },
    {
      label: 'UTM Content',
      value: 'content',
      slug: 'utm_content',
      info: 'Any call-to-action or headline, e.g. buy-now.',
    },
    { label: 'UTM Term', value: 'term', slug: 'utm_term', info: 'Keywords for your paid search campaigns' },
  ];

  return (
    <div className="page-content">
      <h3 className="mb-4">UTM URL Builder</h3>
      <Form>
        <div className="card">
          <div className="card-body p-4">
            <Row>
              {inputsList?.map((elem) => {
                return (
                  <Col md={12} style={{ marginBottom: elem?.value === 'website' ? '30px' : '20px' }} key={elem?.value}>
                    <FormGroup>
                      <Row>
                        <Col xs="2" className="d-flex flex-column justify-content-start">
                          <Label for={elem?.value} className="mb-0 fw-bold">
                            {elem?.label}
                            {elem?.isCompulsory && <span className="text-danger ms-1">*</span>}
                          </Label>
                          {!isEmpty(elem?.slug) && <small className="text-muted">( {elem.slug} )</small>}
                        </Col>

                        <Col xs="10">
                          <Input
                            innerRef={(el) => (textareaRefs.current[elem.value] = el)}
                            type="textarea"
                            rows={1}
                            name={elem?.value}
                            id={elem?.value}
                            placeholder={`Enter ${elem?.label}`}
                            value={utmData[elem?.value]}
                            onChange={handleAutoResize}
                            style={{ overflow: 'hidden', resize: 'none' }}
                          />
                          {!isEmpty(elem?.info) && <small className="text-muted">{elem?.info}</small>}
                        </Col>
                      </Row>
                    </FormGroup>
                  </Col>
                );
              })}
            </Row>

            <FormGroup className="mt-2">
              <Label for="utmResult">Generated UTM TRACKING URL</Label>
              <Input type="textarea" id="utmResult" disabled value={buildUTMUrl()} rows="3" />
              <FormText color="muted">The URL will be generated automatically as you fill the fields.</FormText>
            </FormGroup>
            <div className="d-flex align-items-center gap-4 mt-4">
              <Button
                className="d-flex justify-content-center align-items-center"
                color="primary"
                disabled={isEmpty(buildUTMUrl())}
                onClick={handleCopy}>
                <i className={`bx bx-${copied ? 'check-circle' : 'copy'} me-2 fs-5`} />
                {copied ? 'Copied!' : 'Copy URL'}
              </Button>
              <a
                target="_blank"
                href={`/tools/qr-code-generator?url=${btoa(buildUTMUrl())}`}
                className="btn btn-success"
                disabled={isEmpty(buildUTMUrl())}>
                Generate QR Code
              </a>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default UTMBuilder;
